import { render, staticRenderFns } from "./RetailItemCreate.vue?vue&type=template&id=28614d2b&scoped=true&"
import script from "./RetailItemCreate.vue?vue&type=script&lang=js&"
export * from "./RetailItemCreate.vue?vue&type=script&lang=js&"
import style0 from "./RetailItemCreate.vue?vue&type=style&index=0&id=28614d2b&prod&lang=scss&scoped=true&"
import style1 from "./RetailItemCreate.vue?vue&type=style&index=1&id=28614d2b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28614d2b",
  null
  
)

export default component.exports